import mainGoalsPopupContentQueryParameters from '@atlassian/jira-relay/src/__generated__/GoalsPopupQuery.graphql';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const GoalsEditViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-goals-edit-view" */ './ui/goals'),
	),
	getPreloadProps: ({ cloudId, issueAri }: { cloudId: string; issueAri: string }) => ({
		queries: {
			GoalsPopupQuery: {
				parameters: mainGoalsPopupContentQueryParameters,
				variables: {
					cloudId,
					issueAri,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});

export default GoalsEditViewEntryPoint;
